module.exports = __webpack_public_path__ + "img/抽奖背景2.1362f7a9.png";